import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasMostoles() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Móstoles, Madrid</h1>
        <span className={styles.lastUpdated}>Servicio profesional de mudanzas en Móstoles y alrededores</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-mostoles.webp"
            alt="Mudanzas en Móstoles"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Britosa Mudanzas es tu empresa de confianza para mudanzas en <strong>Móstoles</strong>. Con más de 25 años de experiencia y sede en el corazón de la ciudad (C. Río Duero), conocemos cada calle, cada portal y cada particularidad de mudarse en esta zona del sur de Madrid.
        </p>

        <h2>¿Por qué elegir Britosa para tu mudanza en Móstoles?</h2>
        <p>
          Móstoles es uno de los municipios más poblados de la Comunidad de Madrid, con una elevada rotación de viviendas y una demanda constante de servicios de mudanza profesionales. Nuestro equipo local garantiza tiempos de respuesta rápidos, presupuestos ajustados y un trato cercano que solo una empresa con raíces en la zona puede ofrecer.
        </p>
        <ul>
          <li>Conocimiento exhaustivo de las zonas de carga/descarga de Móstoles.</li>
          <li>Equipo propio sin subcontratación a terceros.</li>
          <li>Seguro a todo riesgo incluido en todos los presupuestos.</li>
          <li>Disponibilidad todos los días de 8:00 a 22:00, incluso fines de semana.</li>
          <li>Presupuesto cerrado sin sorpresas ni costes ocultos.</li>
        </ul>

        <h2>Servicios que ofrecemos en Móstoles</h2>
        <p>
          Desde un estudio en el centro hasta un chalet en las afueras, en Britosa nos adaptamos a cada tipo de mudanza. Nuestros servicios en Móstoles incluyen:
        </p>
        <ul>
          <li><strong>Mudanzas locales:</strong> Dentro de Móstoles o hacia Madrid capital y zona sur (Alcorcón, Fuenlabrada, Leganés).</li>
          <li><strong>Mudanzas nacionales:</strong> Traslados a cualquier punto de España con seguimiento GPS.</li>
          <li><strong>Mudanzas de empresa:</strong> Traslados de oficinas, locales comerciales y despachos profesionales.</li>
          <li><strong>Guardamuebles:</strong> Almacenamiento seguro y climatizado si necesitas tiempo entre mudanzas.</li>
          <li><strong>Embalaje profesional:</strong> Protección integral de cristalería, electrónica y muebles frágiles.</li>
        </ul>

        <h2>Zonas de Móstoles donde operamos</h2>
        <p>
          Cubrimos todos los barrios y zonas del municipio: Centro, Villafontana, Norte, Sur, Este, Parque Coimbra, El Soto, Tecnológico y alrededores. No importa en qué planta vivas o lo estrecho que sea el ascensor: tenemos el equipo y la experiencia para solucionarlo.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Solicita tu presupuesto gratis en Móstoles</h3>
          <p style={{ marginBottom: "1rem" }}>
            Cuéntanos los detalles de tu mudanza y te damos una estimación sin compromiso en menos de 24 horas.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto gratis →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          ¿Tienes dudas? Llámanos al <a href="tel:+34691604880">691 60 48 80</a> o escríbenos a <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>.
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Móstoles",
          "description": "Empresa de mudanzas profesionales en Móstoles, Madrid. Más de 25 años de experiencia.",
          "url": "https://mudanzasbritosa.com/mudanzas-mostoles",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero",
            "addressLocality": "Móstoles",
            "addressRegion": "Madrid",
            "postalCode": "28934",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.3242929,
            "longitude": -3.8632638
          },
          "areaServed": {
            "@type": "City",
            "name": "Móstoles"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
